<template>
  <div id="app">
    <div class="wrap" :class="{positions: helperHeightYn}">
      <HelperHeight :helperHeightYn="helperHeightYn" />
      <div class="payment">
        <!-- 헤더 -->
        <div class="process" v-if="selectYn || bellMobileYn || pagerNumberYn">
          <div class="step-wrap chk-white">
            <span class="step step--n01 on checked">01</span>
            <span class="step-txt">{{ $t('User.OrderCheck.msg1') }}</span>
          </div>
          <div class="step-wrap chk-white" v-if="orderType == 'F'">
            <span class="step step--n02 on checked">02</span>
            <span class="step-txt">{{ $t('User.AdultCertification.msg1') }}</span>
          </div>
          <div class="step-wrap chk-white" v-if="useMembership || useStamp || useCoupon">
            <span class="step step--n02 on checked">{{ orderType == 'F' ? '03' : '02' }}</span>
            <span class="step-txt">{{ $t('User.OrderCheck.msg2') }}</span>
          </div>
          <div class="step-wrap chk-white">
            <span class="step step--n03 on checked">{{
              orderType == 'F' ? (useMembership || useStamp || useCoupon ? '04' : '03') : useMembership || useStamp || useCoupon ? '03' : '02'
            }}</span>
            <span class="step-txt">{{ $t('User.OrderCheck.msg3') }}</span>
          </div>
          <div class="step-wrap chk-white">
            <span class="step step--n04 on">{{
              orderType == 'F' ? (useMembership || useStamp || useCoupon ? '05' : '04') : useMembership || useStamp || useCoupon ? '04' : '03'
            }}</span>
            <span class="step-txt">{{ $t('User.OrderCheck.msg4') }}</span>
          </div>
        </div>

        <!-- 아래 요소 높이 일정해야 함 -->
        <div class="payment__content" v-if="selectYn">
          <!-- header -->
          <div class="layer__header">
            <div class="lyr-title">{{ $t('User.BellSelect.msg1') }}</div>
            <div class="ft-point">{{ $t('User.BellSelect.msg2') }}</div>
            <div class="lyr-txt">{{ $t('User.BellSelect.msg3') }}</div>
          </div>
          <!-- //header -->
          <div class="info-area">
            <div class="info-box" v-if="useAlarmTalk">
              <span class="info-img"><img :src="lineSrc" alt="" /></span>
            </div>
            <div class="info-box" v-if="usePager">
              <span class="info-img"><img :src="pagerSrc" alt="" /></span>
            </div>
          </div>
          <div class="layer__button">
            <button
              v-if="useAlarmTalk"
              class="btn btn--half btn--color btn-anim"
              @mouseup="
                selectYn = false;
                bellMobileYn = true;
                $logInfo(`Bell Select AlarmTalk`);
              "
            >
              {{ $t('User.BellSelect.msg6') }}
            </button>
            <button
              v-if="usePager"
              class="btn btn--half btn--color btn-anim"
              @mouseup="
                selectYn = false;
                pagerNumberYn = true;
                $logInfo(`Bell Select Pager`);
              "
            >
              {{ $t('User.BellSelect.msg7') }}
            </button>
          </div>
        </div>

        <!-- //payment__content -->
        <BellMobile
          v-if="!selectYn && bellMobileYn"
          @closeBellMobile="
            selectYn = true;
            bellMobileYn = false;
            $logInfo(`Close Bell Mobile`);
          "
          @setMobileFinish="setMobileFinish"
        />

        <PagerNumber
          v-if="!selectYn && pagerNumberYn"
          @closePagerNumber="
            selectYn = true;
            pagerNumberYn = false;
            $logInfo(`Close Bell Pager`);
          "
          @setPagerFinish="setPagerFinish"
        />

        <MobileFinish v-if="!selectYn && mobileFinishYn" @closeMobileFinish="mobileFinishYn = true" :tranObj="tranObj" />
        <PagerFinish v-if="!selectYn && pagerFinishYn" @closePagerFinish="pagerFinishYn = true" :pagerOrderNum="pagerOrderNum" :tranObj="tranObj" />

        <OrderFinish
          v-if="!selectYn && orderFinishYn"
          @closeOrderFinish="orderFinishYn = true"
          :finishType="finishType"
          :pagerOrderNum="pagerOrderNum"
          :tranObj="tranObj"
        />

        <div class="btn-bottom-fix-payment">
          <button class="btn--line btn--md btn-anim" @mouseup="staffCallYn = true">
            <i class="ico-staff ico-sm"></i><span>{{ $t('User.Order.msg10') }}</span>
          </button>
          <button class="btn--line btn--md btn-anim" @mouseup="helperYn = true">
            <i class="ico-helper ico-sm"></i><span>{{ $t('User.Order.msg11') }}</span>
          </button>
        </div>
      </div>
      <Helper
        @setDarkYn="
          $store.commit('setDarkModeYn');
          helperYn = false;
        "
        @setHelper="
          helperYn = false;
          staffCallFinishYn = true;
        "
        @setHelperHeight="
          $store.commit('setHelperHeightYn');
          helperYn = false;
        "
        @closeHelper="helperYn = false"
        :helperYn="helperYn"
      />
      <StaffCall
        @closeStaffCall="staffCallYn = false"
        @setStaffCall="
          staffCallYn = false;
          staffCallFinishYn = true;
        "
        :staffCallYn="staffCallYn"
      />
      <StaffCallFinish @closeStaffCallFinish="staffCallFinishYn = false" :staffCallFinishYn="staffCallFinishYn" />
      <AlramConfirm :type="alramType" v-if="alertYn" @setNext="setNext" @setRetry="setRetry" />
    </div>
  </div>
</template>
<script>
import helperHeight from '@/components/common/HelperHeight.vue';
import helper from '@/components/modal/Helper.vue';
import staffCall from '@/components/modal/StaffCall.vue';
import staffCallFinish from '@/components/modal/StaffCallFinish.vue';
import bellMobile from '@/components/user/bellselect/BellMobile.vue';
import mobileFinish from '@/components/user/bellselect/MobileFinish.vue';
import orderFinish from '@/components/user/bellselect/OrderFinish.vue';

import pagerFinish from '@/components/user/bellselect/PagerFinish.vue';
import pagerNumber from '@/components/user/bellselect/PagerNumber.vue';
import audioHelper from '@/js/common/audioHelper.js';
import alertVue from '@/components/modal/alert/AlertSuccess.vue';
import alramConfirm from '@/components/modal/payment/AlramConfirm.vue';

export default {
  name: 'bellSelect',
  methods: {
    setPagerFinish(val) {
      this.pagerOrderNum = val;
      this.orderFinishYn = true;
      this.pagerNumberYn = false;
      this.finishType = 2;
    },
    setMobileFinish(number) {
      if (number === 'skip') {
        this.orderFinishYn = true;
        this.bellMobileYn = false;
        this.finishType = 1;
      } else {
        let param = {
          mobileNo: number,
        };
        
        let items = new Array();
        this.orgBaskets.forEach((basket) => {
          let desc = basket.ITEM_DESC;
          if (this.$store.getters.getPosConfig.posConfig.defaultLanguage == 'KO') {
            desc = basket.ITEM_DESC_KO;
          } else if (this.$store.getters.getPosConfig.posConfig.defaultLanguage == 'JP') {
            desc = basket.ITEM_DESC_JP;
          } else if (this.$store.getters.getPosConfig.posConfig.defaultLanguage == 'EN') {
            desc = basket.ITEM_DESC_EN;
          }

          this.$store.getters.getPosConfig.posConfig.defaultLanguage;
          let item = {
            name: basket.DIS_ITEM_NM,
            price: basket.SALE_UPRC.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + this.currUnitText,
            desc: desc,
          };
          items.push(item);
        });
        param.items = items;

        this.orderFinishYn = true;
        this.bellMobileYn = false;
        this.finishType = 1;
        
      }
    },
    setYes() {
      this.alertYn = false;
    },
    setNext() {
      this.bellMobileYn = false;
      this.pagerNumberYn = false;
      this.finishType = 3;
      this.alertYn = false;
      this.orderFinishYn = true;
    },
    setRetry() {
      this.alertYn = false;
    },
  },
  props: {},
  data() {
    return {
      message: '',
      helperYn: false,
      staffCallYn: false,
      staffCallFinishYn: false,
      bellMobileYn: false,
      selectYn: true,
      mobileFinishYn: false,
      pagerFinishYn: false,
      darkModeYn: this.$store.getters.getDarkModeYn,
      tranObj: JSON.parse(this.$route.params.tran),
      lineSrc: '',
      pagerSrc: '',
      useAlarmTalk: this.$store.getters.getPosConfig.posConfig.useAlarmTalk,
      usePager: this.$store.getters.getPosConfig.posConfig.usePager,
      pagerNumberYn: false,
      pagerOrderNum: 0,
      useMembership: this.$store.getters.getPosConfig.posConfig.supportPayments.indexOf('PAY41') >= 0,
      useCoupon: this.$store.getters.getPosConfig.posConfig.supportPayments.indexOf('PAY47') >= 0,
      useStamp: false,
      orderFinishYn: false,
      orderType: this.$store.getters.getPosConfig.posConfig.templateNo,
      orgBaskets: this.$store.getters.getOrgBaskets,
      alertYn: false,
      text: '',
      currUnitText: this.$store.getters.getCurrUnitText,
      
      alramType: '',
    };
  },
  mounted() {
    if (this.useAlarmTalk && !this.usePager) {
      this.selectYn = false;
      this.bellMobileYn = true;
      this.finishType = 1;
    }
    if (!this.useAlarmTalk && this.usePager) {
      this.selectYn = false;
      this.pagerNumberYn = true;
      this.finishType = 2;
    }
    if (!this.useAlarmTalk && !this.usePager) {
      this.selectYn = false;
      this.orderFinishYn = true;
      this.finishType = 3;
    }

    if (this.$store.getters.getIsSimpleToken === true) {
      // 일본향
      if (this.$i18n.locale == 'jp') {
        this.lineSrc = require('@/assets/images/user/img-alarm-line_jp.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_jp.png');
      } else if (this.$i18n.locale == 'ko') {
        this.lineSrc = require('@/assets/images/user/img-alarm-line_ko.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_ko.png');
      } else if (this.$i18n.locale == 'en') {
        this.lineSrc = require('@/assets/images/user/img-alarm-line_en.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_en.png');
      } else if (this.$i18n.locale == 'cn') {
        this.lineSrc = require('@/assets/images/user/img-alarm-line_cn.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_cn.png');
      } else if (this.$i18n.locale == 'tw') {
        this.lineSrc = require('@/assets/images/user/img-alarm-line_tw.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_tw.png');
      }
    } else {
      // 국내향
      if (this.$i18n.locale == 'jp') {
        this.lineSrc = require('@/assets/images/user/img-alarm-kakao_jp.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_jp.png');
      } else if (this.$i18n.locale == 'ko') {
        this.lineSrc = require('@/assets/images/user/img-alarm-kakao_ko.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_ko.png');
      } else if (this.$i18n.locale == 'en') {
        this.lineSrc = require('@/assets/images/user/img-alarm-kakao_en.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_en.png');
      } else if (this.$i18n.locale == 'cn') {
        this.lineSrc = require('@/assets/images/user/img-alarm-kakao_cn.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_cn.png');
      } else if (this.$i18n.locale == 'tw') {
        this.lineSrc = require('@/assets/images/user/img-alarm-kakao_tw.png');
        this.pagerSrc = require('@/assets/images/user/img-alarm-pager_tw.png');
      }
    }

    this.$changeDarkMode(this.darkModeYn);

    try {
      //this.audio.play(); // 20230406 HSSHIN Audio 재생
      audioHelper.playAudio('00200', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
    } catch (ex) {
      console.error(ex);
    }

    this.$showButtonAnimation();
  },
  unmounted() {
    try {
      //this.audio.pause(); // 20230406 HSSHIN Audio 중지
      audioHelper.stopAudio();
    } catch (ex) {
      console.error(ex);
    }
  },
  created() {},
  beforeCreate() {},
  components: {
    Helper: helper,
    StaffCall: staffCall,
    StaffCallFinish: staffCallFinish,
    BellMobile: bellMobile,
    MobileFinish: mobileFinish,
    PagerFinish: pagerFinish,
    HelperHeight: helperHeight,
    PagerNumber: pagerNumber,
    OrderFinish: orderFinish,
    AlertVue: alertVue,
    AlramConfirm: alramConfirm,
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
    helperHeightYn() {
      return this.$store.getters.getHelperHeightYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    bellMobileYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00201', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    mobileFinishYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00203', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    pagerFinishYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00203', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
<style scoped>
.payment__content,
.dark .payment__content {
  width: 100%;
}

.info-area {
  margin-top: 15vh;
}

.info-box,
.dark .info-box {
  width: auto;
}

.layer__button,
.dark .layer__button {
  width: 100%;
  left: 0;
  justify-content: center;
}

.layer__button button,
.dark .layer__button button {
  width: 37%;
}

.layer__button button + button,
.dark .layer__button button + button {
  margin-left: 2.3vw;
}

.btn-bottom-fix .btn--line + .btn--line,
.dark .btn-bottom-fix .btn--line + .btn--line {
  margin-left: 1.6vw;
}

.btn-bottom-fix .btn--line,
.dark .btn-bottom-fix .btn--line {
  margin-left: 0;
}
</style>
